import React, { useEffect, useRef, useState } from 'react';
import '../../../styles/mainContents.css'
import '../../../styles/navbar.css'
import { fetchConsignmentsCustomer } from '../../../redux/actions/consignmentsPostActions';
import { connect } from 'react-redux';
import MUIDataTable from 'mui-datatables';
import { createTheme, ThemeProvider, styled  } from '@mui/material/styles';
import moment from 'moment';
import { BaseButtonStyle } from '../../../styles/CommonStyling';
// import Button from '@mui/material/Button';
// import Tooltip from '@mui/material/Tooltip';
// import IconButton from '@mui/material/IconButton';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import { FormControl, Select, MenuItem, InputLabel, Checkbox } from "@mui/material";
import { 
  FormGroup, 
  FormControlLabel, 
  Checkbox, 
  Typography, 
  Button,
  Divider 
} from "@mui/material";

function InventoryCount(props) {


  const { fetch_ConsignmentsCustomer, consignmentsCustInventoryState, authreducerState } = props;

  const [catFilterListValues, setCatFilterListValues] = useState(null);
  const [catFilterSelectedValues, setCatFilterSelectedValues] = useState([]);

  const CustomFilterFooter = ({ applyFilters, resetFilters, closeFilterDialog }) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between", // Spreads Reset and Apply
          padding: "8px",
          // CSS TRICK: This moves the footer visually to the top of the dialog content
          order: -1, 
          borderBottom: "1px solid #ddd",
          marginBottom: "10px",
          backgroundColor: "white",
          position: "sticky",
          top: 0,
          zIndex: 100
        }}
      >
        <Button 
          variant="outlined" 
          onClick={resetFilters} 
          color="secondary"
          size="small"
        >
          Reset
        </Button>
        
        <Button 
          variant="contained" 
          onClick={() => {
            applyFilters(); // Apply the selected filters
            closeFilterDialog(); // Close the dialog
          }} 
          color="primary"
          size="small"
        >
          Apply
        </Button>
      </div>
    );
  };

  const handleLineChange = (column, filterList, filterData, updatedFilterIndexList) => {
      const isFilterEmpty = filterList.every((element, index) => { 
        return element.length === 0
      });

      if(isFilterEmpty){
        setCatFilterListValues(null);
        setCatFilterSelectedValues([])
      }
      else{
        let catList= [...new Set(consignmentsCustInventoryState.map( (currentDict, index, array) => {
          if((updatedFilterIndexList.includes(currentDict['LINE']))){
            return currentDict['CAT']
          }
          
          return null
        }
        ))]

        const nullIndex = catList.indexOf(null);
        if (nullIndex !== -1) { 
            catList.splice(nullIndex, 1);
        }

        setCatFilterListValues(catList);      
      } 
      
  };

  const columnsOptions = (colName='', inputType='number', filterEnabled=true, displayType=true, downloadType=true) => {
    var options = {};
    let maxValue = 1000;
    
    colName === 'LAST_COUNTED_DATE' ?
      options = {
        filter: filterEnabled,
        customFilterListOptions: { 
          render: v => `LAST_COUNTED_DATE: ${v}` 
        },
        filterOptions: {
          names: ['Last 7 Days', 'Last 30 Days', 'No Count', 'No Count in 7 Days', 'No Count in 30 Days'],
          logic(thisDate, filterVal){
            const show =
              (filterVal.indexOf('Last 7 Days') >= 0 && moment(new Date(thisDate)).toDate() > moment(new Date()).subtract(7, 'days').toDate()) ||
              (filterVal.indexOf('Last 30 Days') >= 0 && moment(new Date(thisDate)).toDate() > moment(new Date()).subtract(30, 'days').toDate()) ||
              (filterVal.indexOf('No Count') >= 0 && thisDate === null) ||
              (filterVal.indexOf('No Count in 7 Days') >= 0 && moment(new Date(thisDate)).toDate() <= moment(new Date()).subtract(7, 'days').toDate()) ||
              (filterVal.indexOf('No Count in 30 Days') >= 0 && moment(new Date(thisDate)).toDate() <= moment(new Date()).subtract(30, 'days').toDate());
            return !show;
          },
        },             
        sort: true,
        download: downloadType,
        display: displayType,
        responsive: 'standard',
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: "pre-wrap",
            position: "sticky",
            top: '0px',
            zIndex: 101,  
            padding: '8px 4px',       
          }
        }),       
        customBodyRenderLite: (dataIndex, rowIndex) => {        
          return (
            <span style={{whiteSpace: "pre-wrap"}}>  
              <React.Fragment>              
                {consignmentsCustInventoryState[dataIndex][colName]}  
              </React.Fragment>                                                                                  
            </span>
          )                               
        }             
      }     
    :
    colName === 'ONHAND' ?
      options = {
        filter: filterEnabled,
        customFilterListOptions: { 
          render: v => `ONHAND: ${v}` 
        },
        filterOptions: {
          names: ['Onhand = 0'],
          logic(thisQty, filterVal){
            const show =
              (filterVal.indexOf('Onhand = 0') >= 0 && thisQty === 0);
            return !show;
          },
        },             
        sort: true,
        download: downloadType,
        display: displayType,
        responsive: 'standard',
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: "pre-wrap",
            position: "sticky",
            top: '0px',
            zIndex: 101,  
            padding: '8px 4px',       
          }
        }),       
        customBodyRenderLite: (dataIndex, rowIndex) => {        
          return (
            <span style={{whiteSpace: "pre-wrap"}}>  
              <React.Fragment>              
                {consignmentsCustInventoryState[dataIndex][colName]}  
              </React.Fragment>                                                                                  
            </span>
          )                             
        }             
      }     
    :       
    colName === 'CAT' ?
      options = {
        display: displayType,
        filter: filterEnabled,
        customFilterListOptions: { 
          render: v => `CAT: ${v}`,
          // update: (filterList, filterPos, index) => {
          //   console.log('customFilterListOnDelete: ', filterList, filterPos, index);

          //   return filterList;
          // },          
        },
        filterList: catFilterSelectedValues,
        filterOptions: {
          names: catFilterListValues,          
        },             
        sort: true,
        download: downloadType,        
        responsive: 'standard',
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: "pre-wrap",
            position: "sticky",
            top: '0px',
            zIndex: 101,  
            padding: '8px 4px',       
          }
        }),
        //NOTE: don't use custBodyRenderLite here as custBodyRenderLite is not used for filtering           
      }         
    :
    colName === 'LINE' ?
      options = {
        display: displayType,
        filter: filterEnabled,
        filterType: 'custom',
        filterOptions: {
          logic: (line, filters, row) => {
            if (filters.length) return !filters.includes(line);
            return false;
          },          
          display: (filterList, onChange, dataIndex, column, filterData) => {
            const currentSelection = filterList[dataIndex] || [];
            return (
              <div style={{ marginBottom: '16px' }}>
                <Typography variant="subtitle2" style={{ marginBottom: '8px' }}>
                  Line
                </Typography>
                <FormGroup style={{ display:'block' }}>
                  {[...new Set(consignmentsCustInventoryState.map( (currentValue, index, array) => currentValue['LINE']))].map((line) => (
                    <FormControlLabel
                      key={line}
                      label={line}
                      control={
                        <Checkbox
                          checked={currentSelection.includes(line)}
                          onChange={(e) => {
                            const val = e.target.value;
                            let newSelection = [];
                            
                            if (currentSelection.includes(val)) {
                                newSelection = currentSelection.filter(item => item !== val);
                            } else {
                                newSelection = [...currentSelection, val];
                            }

                            filterList[dataIndex] = newSelection;
                            onChange(filterList[dataIndex], dataIndex, column);

                            handleLineChange(column, filterList, filterData, filterList[dataIndex]);
                          }}
                          value={line}
                        />
                      }
                    />
                  ))}
                </FormGroup>
                <Divider />
              </div>
            );
          }        
        },  
        //NOTE: don't use custBodyRenderLite here as custBodyRenderLite is not used for filtering   
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
          <span style={{whiteSpace: "pre-wrap"}}>  
            <React.Fragment>              
              {value}  
            </React.Fragment>                                                                                  
          </span>
          )
        },
        customFilterRender: (filterValue, currentColumnValue, selectedFilters) => {
          // Return true if the row should be included, false if excluded
          if (filterValue.length === 0) {
              return false; // If nothing is selected, don't filter it out.
          }
          return !filterValue.includes(currentColumnValue); 
        },                        
        sort: true,
        download: downloadType,        
        responsive: 'standard',
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: "pre-wrap",
            position: "sticky",
            top: '0px',
            zIndex: 101,  
            padding: '8px 4px',       
          }
        }),
                
      }         
    :    
    options = {
      filter: filterEnabled,
      sort: true,
      download: downloadType,
      display: displayType,
      responsive: 'standard',
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: "pre-wrap",
          position: "sticky",
          top: '0px',
          zIndex: 101,  
          padding: '8px 4px',       
        }
      }),   
      customBodyRenderLite: (dataIndex, rowIndex) => {        
        return (
          <span style={{whiteSpace: "pre-wrap"}}>  
            <React.Fragment>              
              {consignmentsCustInventoryState[dataIndex][colName]}  
            </React.Fragment>                                                                                  
          </span>
        )                             
      }             
    } 
    
    return options;
  }

  const columns = [  
    {
      name: "PRDID",
      label: "Prdid",
      options: {
        filter: false,
        display: "excluded", 
        download:false,
      },
      
    },     
    {
      name: "LINE",
      label: "line",
      options: columnsOptions('LINE', 'text', true, 'excluded', true)
    },
    {
      name: "CAT",
      label: "cat",
      // options: columnsOptions('CAT', 'text', true, 'excluded', true)
      options: columnsOptions('CAT', 'text', true, true, true)
    },    
    {
      name: "PARTNO",
      label: "partno",
      options: columnsOptions('PARTNO', 'text', false, 'excluded', true),
    },
    { 
      name: "LINE_PARTNO",
      label: "LINE\nPARTNO",
      options: columnsOptions('LINE_PARTNO', 'text', false, true, false)
    },    
    {
      name: "DESCRIPTION",
      label: "DESC",
      options: columnsOptions('DESCRIPTION', 'text', false, true, true),
    },  

    {
      name: "CONSIGN_ONHAND_LASTCOUNTEDDATE",
      label: "CON/ON\nCOUNT DATE",
      options: columnsOptions('CONSIGN_ONHAND_LASTCOUNTEDDATE', 'text', false, true, false),
    },    
    {
      name: "ONHAND",
      label: "onhand",
      options: columnsOptions('ONHAND', 'number', true, 'excluded', true),
    },  
    {
      name: "CONSIGN",
      label: "consign",
      options: columnsOptions('CONSIGN', 'number', false, 'excluded', true),
    }, 
    {
      name: "LAST_COUNTED_DATE",
      label: "last_counted_date",
      options: columnsOptions('LAST_COUNTED_DATE', 'text', true, 'excluded', true),
    },              
     
  ]

  const options = {
    filterType: "checkbox",
    confirmFilters: true,  
    onFilterConfirm: (filterList) => {
      console.log('onFilterConfirm');
      console.dir(filterList);
    },    

    filter: true,
    customFilterDialogFooter: (filterList, applyFilters) => {
      return (
        <CustomFilterFooter
          applyFilters={applyFilters}
          resetFilters={() => {
            applyFilters(filterList.map(() => []))
          }} 
          closeFilterDialog={() => {
              document.body.click(); 
          }}
        />
      );
    },              
    fixedHeader: true,
    selectableRows: 'none',
    //responsive: "standard",
    print: false,
    responsive: 'simple',
    tableBodyHeight: "400px",
    searchAlwaysOpen: true,   
    onRowClick: (rowData, rowMeta) => {
    },
    onChangePage (currentPage) {
      console.log({currentPage});
     
    },
    rowsPerPage: 200,
  };  

  const getMuiTheme = () =>
  createTheme({
    overrides: {
      MUIDataTableToolbar: {
        actions: {
          display: "flex",
          flex: "initial",
          // move all icons to the right
          "& > span, & > button": {
            order: 99
          },
          // target the custom toolbar icon
          "& > span:last-child, & > button:last-child": {
            order: 1
          },
          // target any icon
          "& > span:nth-child(4), & > button:nth-child(4)": {
            order: 2
          }
        }
      }
    }
  });



  return (

    <div>
        <div>   
          <div id='consignmentsInventoryCountTblId' className='detailTblClass'>

            { consignmentsCustInventoryState !== undefined && 
              consignmentsCustInventoryState !== null ?
              consignmentsCustInventoryState.length > 0 ?                
                <div>
                  {/* <div>
                    { 
                      (authreducerState.user.role_name === undefined) ? "" :                    
                        (authreducerState.user.role_name !== 'ADMIN' && authreducerState.user.role_name !== 'EDITOR') ? "" :
                        countSubmitBtn()
                    } 
                  </div> */}
                  
                  <table id='inventoryCountTblHeader'>
                    <thead>
                      <tr>
                        <th colSpan='4'>Customer Consignments Inventory Data</th>
                      </tr>
                    </thead>
                    <tbody>                                
                          <React.Fragment>
                            <tr>
                              <td>Customer#:</td>
                              <td>
                                {consignmentsCustInventoryState[0]['CUSTNO']}
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                {consignmentsCustInventoryState[0]['CUSTNAME']} <br/>
                                {consignmentsCustInventoryState[0]['ADDR1']} <br/>
                                {consignmentsCustInventoryState[0]['ADDR2']} {consignmentsCustInventoryState[0]['ADDR2'] !== '' ? (<React.Fragment> <br/> </React.Fragment>) : ''}
                                {consignmentsCustInventoryState[0]['CITY']} {consignmentsCustInventoryState[0]['STATE']} {consignmentsCustInventoryState[0]['ZIP']}
                              </td>
                            </tr>
                          </React.Fragment>                                                         
                    </tbody>
                  </table>

                  <ThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable        
                      data={consignmentsCustInventoryState}
                      columns={columns}
                      options={options}
                    />
                  </ThemeProvider>

                  <div style={{'marginTop':'2em','marginBottom':'2em'}}>
                    <BaseButtonStyle variant="outlined" onClick={() => {
                      window.location.href='/' 
                    }}>BACK
                    </BaseButtonStyle>
                    
                    <BaseButtonStyle variant="contained" onClick={()=>{
                          fetch_ConsignmentsCustomer({custnoInput: consignmentsCustInventoryState[0]['CUSTNO']}, false, true);
                      }}>COUNT
                    </BaseButtonStyle>

                  </div>

     
                </div>


                : ''
              : ''
          
            }

          </div>


        </div>
    </div>

  );
}



const mapStateToProps = (state) => {

 return {
  authreducerState: state.authreducer,

  consignmentsCustInventoryState: state.consignmentsPostReducer['items_fetchConsignmentsCustomerInventory'],
  
 }

};

const mapDispatchToProps = (dispatch) => {
  return {
    fetch_ConsignmentsCustomer: (custnoState, showInventoryOnly, showInventoryCountEdit) => {
        dispatch(fetchConsignmentsCustomer(custnoState, showInventoryOnly, showInventoryCountEdit));
    },    
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InventoryCount);